import React from 'react';
import Icon from '../../../components/AppIcon';

const HistoryStats = ({ data }) => {
  const calculateStats = () => {
    const totalBatches = data?.length;
    const totalProducts = data?.reduce((sum, batch) => sum + batch?.totalProducts, 0);
    const totalSuccess = data?.reduce((sum, batch) => sum + batch?.successCount, 0);
    const totalFailed = data?.reduce((sum, batch) => sum + batch?.failedCount, 0);
    const successRate = totalProducts > 0 ? Math.round((totalSuccess / totalProducts) * 100) : 0;
    
    const completedBatches = data?.filter(batch => batch?.status === 'completed')?.length;
    const failedBatches = data?.filter(batch => batch?.status === 'failed')?.length;
    const inProgressBatches = data?.filter(batch => batch?.status === 'in-progress')?.length;

    return {
      totalBatches,
      totalProducts,
      totalSuccess,
      totalFailed,
      successRate,
      completedBatches,
      failedBatches,
      inProgressBatches
    };
  };

  const stats = calculateStats();

  const statCards = [
    {
      title: 'Total de Lotes',
      value: stats?.totalBatches,
      icon: 'Package',
      color: 'primary',
      bgColor: 'bg-primary/10',
      textColor: 'text-primary'
    },
    {
      title: 'Productos Procesados',
      value: stats?.totalProducts?.toLocaleString('es-ES'),
      icon: 'ShoppingCart',
      color: 'secondary',
      bgColor: 'bg-secondary/10',
      textColor: 'text-secondary'
    },
    {
      title: 'Publicaciones Exitosas',
      value: stats?.totalSuccess?.toLocaleString('es-ES'),
      icon: 'CheckCircle',
      color: 'success',
      bgColor: 'bg-success/10',
      textColor: 'text-success'
    },
    {
      title: 'Publicaciones Fallidas',
      value: stats?.totalFailed?.toLocaleString('es-ES'),
      icon: 'XCircle',
      color: 'error',
      bgColor: 'bg-error/10',
      textColor: 'text-error'
    },
    {
      title: 'Tasa de Éxito',
      value: `${stats?.successRate}%`,
      icon: 'TrendingUp',
      color: stats?.successRate >= 80 ? 'success' : stats?.successRate >= 60 ? 'warning' : 'error',
      bgColor: stats?.successRate >= 80 ? 'bg-success/10' : stats?.successRate >= 60 ? 'bg-warning/10' : 'bg-error/10',
      textColor: stats?.successRate >= 80 ? 'text-success' : stats?.successRate >= 60 ? 'text-warning' : 'text-error'
    },
    {
      title: 'Lotes en Progreso',
      value: stats?.inProgressBatches,
      icon: 'Loader',
      color: 'warning',
      bgColor: 'bg-warning/10',
      textColor: 'text-warning'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-6 mb-6">
      {statCards?.map((stat, index) => (
        <div key={index} className="bg-surface border border-border rounded-lg p-6 hover:shadow-soft transition-shadow">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-text-secondary mb-1">{stat?.title}</p>
              <p className="text-2xl font-bold text-text-primary">{stat?.value}</p>
            </div>
            <div className={`w-12 h-12 ${stat?.bgColor} rounded-lg flex items-center justify-center`}>
              <Icon 
                name={stat?.icon} 
                size={24} 
                className={`${stat?.textColor} ${stat?.icon === 'Loader' && stats?.inProgressBatches > 0 ? 'animate-spin' : ''}`}
              />
            </div>
          </div>
          
          {/* Progress bar for success rate */}
          {stat?.title === 'Tasa de Éxito' && (
            <div className="mt-3">
              <div className="w-full bg-muted rounded-full h-2">
                <div 
                  className={`h-2 rounded-full transition-all duration-500 ${
                    stats?.successRate >= 80 ? 'bg-success' : 
                    stats?.successRate >= 60 ? 'bg-warning' : 'bg-error'
                  }`}
                  style={{ width: `${stats?.successRate}%` }}
                ></div>
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default HistoryStats;